class ManagedTesterTestStatusReportModalController {
    constructor($window) {
        this.cancel = () => {
            this.dismiss();
        };
        this.$onInit = () => {
            let params = this.resolve;
            this.simId = -1;
            this.testerId = params.testerId;
        };
        this.window = $window;
    }
}
angular.module('app').component('managedTesterTestStatusReportModal', {
    templateUrl: 'Scripts/App/partials/Reports/managed-tester-test-status-report-modal.tpl.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    controllerAs: 'vm',
    controller: ManagedTesterTestStatusReportModalController
});
